export const OPEN_PRICING_MODAL = 'OPEN_PRICING_MODAL';
export const CLOSE_PRICING_MODAL = 'CLOSE_PRICING_MODAL';
